import * as yup from "yup";
import FormConstants from "../constants/Form.constants";

const projectSearchSchema = yup.object().shape({
  searchTerm: yup
    .string()
    .min(3, FormConstants.FeedbackMessages.searchTermMin)
    .max(70, FormConstants.FeedbackMessages.searchTermMax)
    .required(FormConstants.FeedbackMessages.searchTermRequired),
});

export default {
  projectSearchSchema,
};
